import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import logo from '../componts/img/logo_no_bg.png';
import Navbar from '../componts/navcus.js';
import Home from '../contents/home.js';
import RDandInnovation from "../contents/our_project/Rand_innovation.js";
import Hydrogen from "../contents/our_project/hybrid_technologies/hydrogen.js";
import Hydraulic from "../contents/our_project/hybrid_technologies/hydraulic.js";
import HydroVerraProject from '../contents/our_project/hydrocharge.js';
import Footer from '../componts/footer.js';
import Mobcus from '../componts/cusmobilenav.jsx';

// Lazy-loaded routes for code-splitting
const Careers = lazy(() => import('../contents/careers/careers.js'));
const News = lazy(() => import('../contents/news/news.js'));
const Www = lazy(() => import('../contents/aboutus/WhoWeAre.js'));
const OurMission = lazy(() => import('../contents/aboutus/OurMission.js'));
const OurVision = lazy(() => import('../contents/aboutus/OurVision.js'));
const Application = lazy(() => import('../contents/application/Application.js'));
const EVCharging = lazy(() => import('../contents/sectors/EVCharging.js'));
const Events = lazy(() => import('../contents/sectors/Events.js'));
const RuralRemote = lazy(() => import('../contents/sectors/RuralRemote.js'));
const PortsMaritime = lazy(() => import('../contents/sectors/PortsMaritime.js'));
const Emergency = lazy(() => import('../contents/sectors/Emergency.js'));
const Construction = lazy(() => import('../contents/sectors/Construction.js'));
const PublicSector = lazy(() => import('../contents/sectors/PublicSector.js'));
const FilmProduction = lazy(() => import('../contents/sectors/FilmProduction.js'));
const OurCoreValues = lazy(() => import('../contents/aboutus/OurCoreValues.js'));
const Impact = lazy(() => import('../contents/impact/impact.js'));
const Form = lazy(() => import('../contents/careers/form.js'));
const OffshoreTech = lazy(() => import('../contents/what_we_do/Technology/offshoreWind.js'));
const HydroVerra = lazy(() => import('../contents/what_we_do/Technology/HydroVerra.js'));
const HydroCell = lazy(() => import('../contents/what_we_do/Technology/HydraCell.js'));
const Zyraxon = lazy(() => import('../contents/what_we_do/Technology/Zyraxon.js'));
const SolarTech = lazy(() => import('../contents/what_we_do/Technology/solar.js'));
const Tidal = lazy(() => import('../contents/what_we_do/Technology/tidal.js'));
const DesignAnalysis = lazy(() => import('../contents/what_we_do/Engieering/design_analysis.js'));
const Testing = lazy(() => import('../contents/what_we_do/Engieering/testing.js'));
const Optimization = lazy(() => import('../contents/what_we_do/Engieering/optimization.js'));
const RepairMaintenance = lazy(() => import('../contents/what_we_do/Engieering/repair_Maintenance.js'));
const Procurement = lazy(() => import('../contents/what_we_do/Engieering/Procurement.js'));
const RenewableEnergy = lazy(() => import('../contents/what_we_do/R&D/Renewable_Energy_Innovation.js'));
const BiomimeticTechnology = lazy(() => import('../contents/what_we_do/R&D/Biomimetic.js'));
const GeneralMechanics = lazy(() => import('../contents/what_we_do/R&D/General_Mechanics.js'));
const NumericalToolsDevelopment = lazy(() => import('../contents/what_we_do/R&D/Numerical_Tools_Development.js'));
const ConferenceAndPublications = lazy(() => import('../contents/what_we_do/R&D/Conferences_Publications.js'));
const Partnership = lazy(() => import('../contents/what_we_do/R&D/Strategic_Partnerships.js'));
const ContactUs = lazy(() => import('../contents/contactus/contactus.js'));
const Terms = lazy(() => import('../contents/legal/Terms.js'));
const Privacy = lazy(() => import('../contents/legal/Privacy.js'));

// Loading fallback component
const RouteLoader = () => <div style={{ textAlign: 'center', padding: '2rem' }}>Loading...</div>;
export default function Root() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <BrowserRouter>
            <div className="global-watermark" aria-hidden="true">
                <img src={logo} alt="" />
            </div>
            {isMobile ? < Mobcus/> : <Navbar /> }
            <Suspense fallback={<RouteLoader />}>
                <main className="site-main">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path='/about_us/who_we_are' element={<Www/>}/>
                    <Route path="/about_us/our_mission" element={<OurMission />} />
                    <Route path="/about_us/our_vision" element={<OurVision />} />
                    <Route path="/about_us/our_core_values" element={<OurCoreValues />}/>

                    <Route path="/careers" element={<Careers />} />

                    <Route path="/contact" element={<Navigate to="/contactus" replace />} />
                    <Route path="/form" element={<Form />} />
                    <Route path="/ourtechnology/offshore" element={<OffshoreTech />} />
                    <Route path="/ourtechnology/HydroVerra" element={<HydroVerra />} />
                    <Route path="/ourtechnology/HydraCell" element={<HydroCell />} />
                    <Route path="/ourtechnology/Zyraxon" element={<Zyraxon />} />
                    <Route path="/ourtechnology/solar" element={<SolarTech />} />
                    <Route path="/ourtechnology/tidal" element={<Tidal />} />
                    <Route path="/Engineering/design_analysis" element={<DesignAnalysis />} />
                    <Route path="/Engineering/testing" element={<Testing />} />
                    <Route path="/Engineering/optimization" element={<Optimization />} />
                    <Route path="/Engineering/repair_maintenance" element={<RepairMaintenance />} />
                    <Route path="/Engineering/procurement" element={<Procurement />} />
                    <Route path="/r_d/renewable_energy" element={<RenewableEnergy />} />
                    <Route path="/r_d/biomimetic_technology" element={<BiomimeticTechnology />} />
                    <Route path="/r_d/general_mechanics" element={<GeneralMechanics />} />
                    <Route path="/r_d/Numerical_tools_Development" element={<NumericalToolsDevelopment />} />
                    <Route path="/r_d/conference_and_publications" element={<ConferenceAndPublications />} />
                    <Route path="/r_d/Strategic_Partnerships" element={<Partnership />} />
                    <Route path="/sectors" element={<Application />} />
                    <Route path="/sectors/ev-charging" element={<EVCharging />} />
                    <Route path="/sectors/events" element={<Events />} />
                    <Route path="/sectors/rural-remote" element={<RuralRemote />} />
                    <Route path="/sectors/ports-maritime" element={<PortsMaritime />} />
                    <Route path="/sectors/emergency" element={<Emergency />} />
                    <Route path="/sectors/construction" element={<Construction />} />
                    <Route path="/sectors/public-sector" element={<PublicSector />} />
                    <Route path="/sectors/film-production" element={<FilmProduction />} />
                    <Route path="/impact" element={<Impact />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/contactus" element={<ContactUs />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/ourprojects/HydroVerra" element={<HydroVerraProject />} />
                    <Route path="/ourprojects/r&d-innovation" element={<RDandInnovation />} />
                    <Route path="/ourprojects/hybrid-energy/hydrogen" element={<Hydrogen />} />
                    <Route path="/ourprojects/hybrid-energy/hydraulic" element={<Hydraulic />} />
                </Routes>
                </main>
                <Footer />
            </Suspense>
        </BrowserRouter>
    );
}
